import {GameFeatureFilterDefinitionBase} from "../game-feature-filter-definition-base";
import {GameInfo} from "../../../games/game-info";

export class HasNoJackpotFilterDefinition extends GameFeatureFilterDefinitionBase {
    get id(): string {
        return "has-no-jackpot";
    }

    get text(): string {
        return this.services.translation.translate('NO_JACKPOT');
    }

    protected _shouldIncludeGame(gameInfo: GameInfo): boolean {
        return !gameInfo.hasJackpot;
    }
}